import React from 'react';
import {format, parseISO} from 'date-fns';
import classNames from 'classnames';
import PopupConfirmReplacement from '../PopupConfirmReplacement';
import {CurrentMonthInvoice} from '../../../../common/types';
import {Format} from '../../../../common/utils';
import styles from './InvoiceListItem.module.scss';

const InvoiceListItem = (invoice: CurrentMonthInvoice) => {

  return (
    <div className={styles.lineContainer}>
      <div className={classNames(styles.column, styles.truncateColumn)}>
        {invoice?.id}
      </div>
      <div className={classNames(styles.column, styles.truncateColumn)}>
        {[invoice?.customer?.name?.first, invoice?.customer?.name?.last].filter(Boolean).join(' ')}
      </div>
      <div className={classNames(styles.column, styles.truncateColumn)}>
        {format(parseISO(invoice?.datetime), 'dd/MM/yyyy')}
      </div>
      <div className={classNames(styles.column, styles.truncateColumn)}>
        {Boolean(invoice?.amount) ? Format.displayFloatThousandsWithCommas(invoice?.amount) : ''}
      </div>
      <div className={classNames(styles.column, styles.actionColumn)}>
        <PopupConfirmReplacement
          invoiceID={invoice?.id}
          customerEmail={invoice.customer.email}
          datetime={invoice.datetime}
        />
      </div>
    </div>
  );
};

export default InvoiceListItem;
